"use strict";

module.exports = {
    initialize: function initialize() {
        var _this = this;

        // attach to the global notifier
        this.notifier.push(this);

        this.addDisposable({
            dispose: function dispose() {
                _this.notifier.remove(_this);
            }
        });
    },
    notify: function notify() {
        // OVERRIDE ME
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/models/mixins/watch-notifications.js
 ** module id = 511
 ** module chunks = 0 1
 **/